module.exports = __webpack_public_path__ + "static/logo-ec5b0ef65a203f8ddd6b36992fd73389.svg";